import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Card from '../Components/Card';

// Images
import Stonk_Home from '../Assets/Images/Stonk.png';
import Post_Page from '../Assets/Images/Stonk-Post-Page.png';
import Stock_Page from '../Assets/Images/Stonk-Stock-Page.png';

class Stonk_Carousel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [
                {
                    id: 0,
                    title: "",
                    subTitle: "",
                    imgSrc: Stock_Page,
                    link: "",
                    selected: false
                },
                {
                    id: 1,
                    title: "",
                    subTitle: "",
                    imgSrc: Stonk_Home,
                    link: "",
                    selected: false
                },
                {
                    id: 2,
                    title: "",
                    subTitle: "",
                    imgSrc: Post_Page,
                    link: "",
                    selected: false
                }
            ]
        }
    }

    handleCardClick = (id, card) => {
        let items = [...this.state.items];

        items[id].selected = items[id].selected ? false : true;

        items.forEach(item => {
            if (item.id !== id) {
                item.selected = false;
            }
        });

        this.setState( {
            items
        });
    }

    makeItems = (items) => {
        return items.map(item => {
            return <Card item={item} click={(e => this.handleCardClick(item.id, e))} key={item.id} />
        })
    }

    render() {
        return (
            <Container fluid={true} className="Carousel-Container-sv">
                <Row className="justify-content-around">
                    {this.makeItems(this.state.items)}
                </Row>
            </Container>
        );
    }

}

export default Stonk_Carousel;